
import { createContext, useContext, useState } from "react";
import { Link, Route, Routes } from "react-router-dom";
import styles from '../../../css/StaffMgmt.module.css';
import titleStyle from '../../../css/SectionTitle.module.css';
import { BsList } from "react-icons/bs";
import { MenuContext } from "../DashBoard";
import AddResult from "./AddUserResult";
import { ResultContext } from "./ResultMgmt";
import ViewUserResult from "./ViewUserResults";


const Result = ()=>{
    const {showMenu, setShowMenu} = useContext(MenuContext);
    const {title, clearEdit} = useContext(ResultContext)
    return (

            <div className={`${styles.baseView}`} style={{ display: 'flex', flexWrap: 'wrap' }}>
                <h1 className={`${styles.title}`}>Result</h1>
                <div className={`${styles.subView}`}>
                    <div className={titleStyle.sectionTitle}>
                        <h3 className={titleStyle.h3}>
                            {title}
                        </h3>
                        <div className={`${titleStyle.menuDiv}`}>
                            <span className={`${titleStyle.menuBtn}`} onClick={() => setShowMenu(!showMenu)}><BsList />Menu</span>
                            {showMenu &&
                                <div className={`${titleStyle.subMenu}`} >
                                    <ul>
                                        <li><Link to='add-result'>Add User Result</Link></li>
                                        <li onClick={clearEdit}><Link to='view-result'>View Users Result</Link></li>
                                    </ul>
                                </div>
                            }
                        </div>
                    </div>
                    
                    
                    <Routes>
                        <Route element={<AddResult />} path={'/add-result'} />
                        <Route element={<ViewUserResult />} path={'/view-result'} />
                        <Route element={<ViewUserResult />} path={'/*'} />
                    </Routes>
                </div>
            </div>
    );
}
export default Result;